import "../../../../stylesheets/views/shared/public/terms.scss"

